module.exports = __webpack_public_path__ + "img/inter22.5aeb24fe.jpg";